import { render, staticRenderFns } from "./BoasVindas.vue?vue&type=template&id=1ff9fae1&scoped=true"
import script from "./BoasVindas.vue?vue&type=script&lang=js"
export * from "./BoasVindas.vue?vue&type=script&lang=js"
import style0 from "./BoasVindas.vue?vue&type=style&index=0&id=1ff9fae1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff9fae1",
  null
  
)

export default component.exports